/**
 * 模板审核状态
 */
export enum AuditStatus {
  /** 编辑中 */
  Edit = 'edit',
  /** 渲染中 */
  Review = 'review',
  /** 渲染失败 */
  ReviewFailed = 'review_failed',
  /** 已提交，待审核 */
  WaitReview = 'wait_review',
  /** 审核通过 */
  Approved = 'approved',
  /** 审核不通过 */
  rejected = 'rejected',
}

/**
 * 模板类型
 */
export enum TemplateType {
  /** 个人模板 */
  Personal = 'personal',
  /** 布局模板 */
  Common = 'common',
  /** 内容模板 */
  Content = 'content',
}

/** 上架状态 */
export enum ShowStatus {
  /** 未上架 */
  Not = 1,
  /** 已上架 */
  Yes = 2,
  /** 上架中 */
  Publishing = 3,
  /** 上架失败 */
  PublishFail = 4,
  /** 已下架 */
  Published = 5,
}
